export default "__VITE_ASSET__BjRgIDVw__"